import { ISusuarioList, UsuarioList } from '../../types/usuario/UsuarioList';
import { ISmenuFilhoList, MenuFilhoList } from '../menuFilho/MenuFilho';
import { ISnoticiaList, NoticiaList } from '../noticia/Noticia';

export interface MenuNeto {
  id?: string;
  label: string;
  link?: string;
  noticia?: NoticiaList;
  menuFilho?: MenuFilhoList;
  children?: MenuNeto[];
  dataHoraCriacao?: Date | string;
  usuario?: UsuarioList;
  ordem?: number;
  isEscolaLegislativo?: boolean;
}

export const ISmenuNeto: MenuNeto = {
  id: '',
  label: '',
  children: [],
  link: '',
  noticia: ISnoticiaList,
  menuFilho: ISmenuFilhoList,
  dataHoraCriacao: '',
  usuario: ISusuarioList,
  ordem: 0,
  isEscolaLegislativo: false
};

export interface MenuNetoDTO {
  id?: string;
  idFilho: string;
  link: string;
  idNoticia?: string;
  label: string;
  ordem: number;
  isEscolaLegislativo?: boolean;
}
export const ISmenuNetoDTO: MenuNetoDTO = {
  id: '',
  idFilho: '',
  link: '',
  idNoticia: '',
  label: '',
  ordem: 0,
  isEscolaLegislativo: false
};

export interface MenuNetoList {
  id: string;
  label: string;
  link: string;
  ordem?: number;
  idNoticia: string;
  menuFilho: MenuFilhoList;
  dataHoraCriacao?: Date | string;
  usuario: UsuarioList;
  isEscolaLegislativo?: boolean;
}
export const ISmenuNetoList: MenuNetoList = {
  id: '',
  label: '',
  link: '',
  ordem: 0,
  idNoticia: '',
  menuFilho: ISmenuFilhoList,
  dataHoraCriacao: '',
  usuario: ISusuarioList,
  isEscolaLegislativo: false
};
